import { axiosInstance } from 'src/util/axios/instance.axios'
import { MyDashboard, DownloadReportFormData } from '../model/dashboard-model'

export async function downloadReport(reportData: DownloadReportFormData): Promise<any> {
  const { data } = await axiosInstance.request<any>({
    url: '/dashboard/download-report',
    method: 'POST',
    data: reportData,
    responseType: 'arraybuffer',
    headers: {
      'Content-Type': 'application/json',
    },
  })

  return data
}

export async function getMyDashboard(): Promise<MyDashboard> {
  const { data } = await axiosInstance.request<MyDashboard>({
    url: `/dashboard/my-dashboard`,
  })

  return data
}

export async function getUserDashboard(userId: string): Promise<MyDashboard> {
  const { data } = await axiosInstance.request<MyDashboard>({
    url: `/dashboard/my-dashboard/${userId}`,
  })

  return data
}
